export function sharedUtilsTokens(): string {
  return 'shared-utils-tokens';
}
